import Vue from 'vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import App from './App'
import messages from '../comm/i18n/index'
import uploader from 'vue-simple-uploader'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/hint/show-hint.css'
import './plugins'
import './assets/style/layout.scss'
import * as filters from '../comm/filters' // 全局vue filter
import './assets/iconfont/iconfont.css'
Vue.use(VueI18n)
/* i18n */
const i18n = new VueI18n({
  locale: 'zh-hans',
  fallbackLocale: 'zh-hans',
  messages
})
/* axios */
import axios from '../comm/api'
import api from '../comm/api/api'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.prototype.http = axios
Vue.prototype.api = api

Vue.config.productionTip = false

window.themeConfig = [{ key: 'light', value: '白色系' }, { key: 'dark', value: '黑色系' },{ key: 'green', value: '绿色系' }]
if (!localStorage.getItem('theme')) {
  // 默认主题
  localStorage.setItem('theme', 'light')
}

document.body.className = localStorage.theme ? 'body-theme-' + window.themeConfig.filter(v => v.key === localStorage.theme)[0].key :
  'body-theme-' + window.themeConfig[0].key

//ElementUI
import '../comm/assets/style/index.scss'
// import '../comm/assets/style/theme/theme-light/theme/index.css'
// import '../comm/assets/style/theme/theme-dark/theme/index.css'

import ElementUI from 'element-ui';
Vue.use(ElementUI);
Vue.use(uploader);
Vue.use(codemirror);
import '../comm/assets/style/layout.scss'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/workspace/main.js